// File: src/context/AuthContext.js

import React, { createContext, useState, useEffect } from 'react';
import {
  getUserId,
  getAuthCode,
  getUserRoles,
  setCredentials,
  clearCredentials
} from '../api/authStorage';
import {
  validateAdmin as apiValidateAdmin,
  login as apiLogin,
  logout as apiLogout   // ← import the API logout
} from '../api/auth';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser]       = useState(null);
  const [roles, setRoles]     = useState(getUserRoles());
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedUserId   = getUserId();
    const storedAuthCode = getAuthCode();

    if (storedUserId && storedAuthCode) {
      apiValidateAdmin()
        .then(u => {
          setUser(u);
          setRoles(u.roles || getUserRoles());
        })
        .catch(() => {
          // invalid/expired credentials
          clearCredentials();
          setUser(null);
          setRoles([]);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (usernameOrEmail, password) => {
    setLoading(true);
    try {
      const { userId, authCode, roles: newRoles, user: u } =
        await apiLogin(usernameOrEmail, password);

      setCredentials(authCode, userId, newRoles);
      setUser(u);
      setRoles(newRoles);
    } finally {
      setLoading(false);
    }
  };

  const logout = async () => {
    // call your API logout endpoint
    try {
      await apiLogout();
    } catch (err) {
      console.error('API logout failed:', err);
    }
    // then clear local storage and state
    clearCredentials();
    setUser(null);
    setRoles([]);
  };

  return (
    <AuthContext.Provider value={{ user, roles, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
